<template>
  <modal :key="_key" :show.sync="modalVisible" modal-classes="modal-lg" @close="$emit('closeClicked')">
    <h4 slot="header">{{modalTitle || 'Select User'}} {</h4>
    <UserPicker
      :_key="_key"
      :key="_key"
      :value="value"
      :title="title"
      :multi="multi"
      :skipList="skipList"
      :role="role"
      :defaults="defaults"
      @userSelected="_onUserSelected"
      @userRemoved="_onUserRemoved"
    />
    <!-- <template slot="footer">
      <base-button type="secondary" @click="$emit('closeClicked')"
        >Close</base-button
      >
      <base-button type="success" @click="onSaveClicked">Save</base-button>
    </template> -->
  </modal>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import UserPicker from "@/app/components/UserPicker.vue";
export default {
  name: "UserPickerModal",
  components: {
    UserPicker,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Object, Array],
    },
    
    title: String,
    modalTitle: String,
    multi: {
      type: Boolean,
      default: false,
    },
    role: String,
    _key: Number,
    skipList: {
      type: Array,
      default: () => []
    },
    defaults: {
      type: Array,
      default: () => []
    },
    saveOnUserSelect: {
      type: Boolean,
      default:true
    }
  },
  data() {
    return {
      showAssignedByModal: this.show,
    };
  },

  watch: {
    
  },

  computed: {
    modalVisible: {
      get(){
        return this.visible
      },

      set(newName){
        return newName
      }

    }
  },
  mounted() {

  },
  methods: {
    onSaveClicked(v) {
      
      this.$emit("input", v);
      this.$emit("okClicked", v);
      
    },
    _onUserSelected(v) {
     
      this.$emit("input", v);
      if(this.saveOnUserSelect)
        this.$emit("okClicked", v);
    },
    _onUserRemoved(v) {
      //console.log(v)
      this.$emit("input", v);
      this.$emit("okClicked", v);
    }
  },
};
</script>
